// extracted by mini-css-extract-plugin
export default {"rating":"HA-z","numberOfStars":"IA-z","count":"JA-z","barGraphSpacing":"KA-z","barGraph":"LA-z"};